import { Icon } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { StyledAlert } from './styles'
import { AlertProps } from './types'

export const Alert: FC<AlertProps> = ({ Icon: IconProp, children }) => {
  return (
    <StyledAlert>
      {IconProp && <Icon Icon={IconProp} size={6} style={{ flexShrink: 0 }} />}
      {children}
    </StyledAlert>
  )
}
